import React from 'react';

const ConstructionPage: React.FC = () => {
  return (
    <div className="h-[85vh] w-full flex items-center justify-center ">
      <div className="text-white text-9xl">🚧</div>
    </div>
  );
};

export default ConstructionPage;
